/**
 * Firma bakiyeleri — firmabakiyeler.js ile aynı hasEsdeger mantığı (tüm geçmiş).
 */
import { collection, getDocs, query } from 'firebase/firestore';
import { db } from '../firebase';
import { formatQtyTr } from './gunsonuWhatsappReport';

/**
 * @returns {Promise<{ rows: Array<{firmaIsmi:string,toplamHas:number}>, genelToplam: number }>}
 */
export async function fetchFirmaBakiyeleri(sube) {
  if (!sube) return { rows: [], genelToplam: 0 };

  const snap = await getDocs(query(collection(db, 'subeler', sube, 'islemler')));
  const firmaMap = {};

  snap.forEach((docSnap) => {
    const data = docSnap.data();
    const firmaIsmi = data?.firma?.firmaIsmi?.trim?.();
    if (!firmaIsmi) return;

    if (!firmaMap[firmaIsmi]) {
      firmaMap[firmaIsmi] = { toplamHas: 0 };
    }

    const hasEsdeger = parseFloat(data.hasEsdeger) || 0;
    if (hasEsdeger <= 0) return;

    const tur = data.islemTuru || '';
    if (['Giriş', 'Alış', 'İade', 'Değişim'].includes(tur)) {
      firmaMap[firmaIsmi].toplamHas += hasEsdeger;
    } else if (['Çıkış', 'Satış'].includes(tur)) {
      firmaMap[firmaIsmi].toplamHas -= hasEsdeger;
    }
  });

  const rows = Object.entries(firmaMap)
    .map(([firmaIsmi, v]) => ({
      firmaIsmi,
      toplamHas: parseFloat(v.toplamHas.toFixed(2)),
    }))
    .sort((a, b) => a.firmaIsmi.localeCompare(b.firmaIsmi, 'tr'));

  const genelToplam = parseFloat(
    rows.reduce((s, r) => s + (Number(r.toplamHas) || 0), 0).toFixed(2)
  );

  return { rows, genelToplam };
}

export function formatFirmaBakiyePdfRows(firmaPayload) {
  const rows = Array.isArray(firmaPayload?.rows) ? firmaPayload.rows : [];
  const body = rows.map((r) => [String(r.firmaIsmi), formatQtyTr(r.toplamHas, 2)]);
  if (rows.length) {
    body.push(['GENEL TOPLAM', formatQtyTr(firmaPayload.genelToplam ?? 0, 2)]);
  }
  return body;
}
